import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, Event as RouterEvent, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from '../../../users/shared/user.service';

/**
 * Toolbar that goes at the top of the app.
 * This toolbar chooses the right module toolbar based on the route.
 */
@Component({
  selector: 'wl-module-toolbar',
  templateUrl: 'module-toolbar.component.html',
    standalone: false
})
export class WlModuleToolbarComponent implements OnInit, OnDestroy {
  @Output() public sectionChange: EventEmitter<string> = new EventEmitter<string>();
  public _section: string = '';
  public _routerSubscription: Subscription = null;

  /**
   * injection
   * @param _router
   */
  public constructor(public _router: Router) { }

  /**
   * setup
   */
  public ngOnInit(): void {
    this._routerSubscription = this._router.events.subscribe((event: RouterEvent) => {
      if (!(event instanceof NavigationEnd)) return;

      let navigationEndEvent: NavigationEnd = <NavigationEnd>(<any>event);
      let url: string = navigationEndEvent.urlAfterRedirects == null ? '' : navigationEndEvent.urlAfterRedirects.toLocaleLowerCase();

      // if there's a hash in the URL, strip it plus anything after it out
      if (url.indexOf('#') > 0) {
        url = url.substring(0, url.indexOf('#'));
      }

      if (url.startsWith('/event/') || url.startsWith('/events/') || url.startsWith('/events?') || url == '/events') {
        // prevent lots of digest changes
        if (this._section != 'events') {
          this._section = 'events';
          this.sectionChange.emit(this._section);
        }
      } else if (
        url.startsWith('/profile/') ||
        url.startsWith('/profiles/') ||
        url.startsWith('/profiles?') ||
        url == '/profiles' ||
        url.startsWith('/admin/restore-profile') ||
        url.startsWith('/dashboard')
      ) {
        // prevent lots of digest changes
        if (this._section != 'profiles') {
          this._section = 'profiles';
          this.sectionChange.emit(this._section);
        }
      } else if (
        url.startsWith('/events-v4/') ||
        url.startsWith('/events-v4?') ||
        url.startsWith('/events-v4')
      ) {
        // prevent lots of digest changes
        if (this._section != 'events-v4') {
          this._section = 'events-v4';
          this.sectionChange.emit(this._section);
        }
      } else if (url.startsWith('/revenue/') || url == '/revenue') {
        // prevent lots of digest changes
        if (this._section != 'revenue') {
          this._section = 'revenue';
          this.sectionChange.emit(this._section);
        }
      } else if (this._section != '') {
        this._section = '';
        this.sectionChange.emit(this._section);
      }
    });
  }

  /**
   * clean up
   */
  public ngOnDestroy(): void {
    if (this._routerSubscription) this._routerSubscription.unsubscribe();
  }
}
